export const SOFTLINE_PERMISSION_STEMPELTERMINAL = 'STEMPELTERMINAL';
